/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { createObservableDataAction, IAction, IActionInput, IAny, ICreateActionContext, IGeneric } from '@msdyn365-commerce/core';
import { GenericInput, getGenericAction } from '@msdyn365-commerce-modules/retail-actions';

import { IDistributorSelectorStateManager } from './i-distributor-selection-state-manager';
import { MapDistributorSelectorStateManager } from './map-distributor-selector-state-manager';

export function createDistributorSelectorStateInput(
    result: IDistributorSelectorStateManager
): GenericInput<IDistributorSelectorStateManager> {
    return new GenericInput<IDistributorSelectorStateManager>('mapDSSM', result, 'IDistributorSelectorStateManager');
}

const createDistributorSelectorStateInputInternal = (inputData: ICreateActionContext<IGeneric<IAny>>): IActionInput => {
    return createDistributorSelectorStateInput(new MapDistributorSelectorStateManager());
};

export const getGenericActionDataAction = createObservableDataAction({
    action: <IAction<IDistributorSelectorStateManager>>getGenericAction,
    input: createDistributorSelectorStateInputInternal
});

export default getGenericActionDataAction;
